import { render, staticRenderFns } from "./HandicapSummaryData.vue?vue&type=template&id=877a9486&scoped=true"
import script from "./HandicapSummaryData.vue?vue&type=script&lang=js"
export * from "./HandicapSummaryData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877a9486",
  null
  
)

export default component.exports